import { target_date } from './base';

export interface PurchaseRequestMisc {
  id?: number | string;
  description: any;
  unit: string;
  amount: number;
  targetDate: Date;
}
export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    description: {
      name: 'ชิ้นส่วน',
      width: '1fr',
    },
    amount: {
      name: 'จำนวน',
      width: '5rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
    },
    target_date,
  },
};
